import { useControlField, useField } from 'remix-validated-form'
import { ClientLazy, FieldContainer } from '~/components'

type HtmlEditableFieldProps = {
  className?: string
  label: string
  name: string
  isList?: boolean
  description?: string
  required?: boolean
  onBlur?: () => void
}

export default function HtmlEditableField(props: HtmlEditableFieldProps) {
  const { className, label, name, onBlur } = props
  const [value, setValue] = useControlField<string>(name)
  const { getInputProps } = useField(name)
  const { onBlur: inputOnBlur } = getInputProps()

  return (
    <FieldContainer label={label} className={className}>
      <input name={name} type="hidden" value={value || ''} />
      <ClientLazy
        value={value}
        setValue={setValue}
        onBlur={onBlur ?? inputOnBlur}
        component={() => import('./HtmlCkEditor')}
        fallback={() => <div className="h-44 w-full bg-muted/50" />}
      />
    </FieldContainer>
  )
}
